import { isEmpty } from 'lodash';
import { FC } from 'react';
import { IntlShape } from 'react-intl';

import LegalNotice from './LegalNotice';

import PriceTableText from './PriceTableText';

import { useMedia } from '../../../context/InterfaceContext';
import Divider from '../../shared/Divider';
import { Cell, Col, Table } from '../../shared/table';

const Prices: FC<{
    intl: IntlShape;
    prices: Array<{ days: string | number; price: string | number; subline: string }> | null;
    pricingText: Array<{ href: string; text: string; title: string }> | null;
}> = ({ prices, intl, pricingText }) => {
    const { isMobileOrTablet } = useMedia();
    const padding = `0 ${isMobileOrTablet ? 20 : 30}px`;

    if (!!prices && !isEmpty(prices)) {
        return (
            <>
                <section className="product-page__prices-wrapper">
                    <h3>{intl.formatMessage({ id: 'product.pricesTitle', defaultMessage: 'Preise' })}</h3>

                    <div>
                        <Table w={'100%'} fd={'row'}>
                            {prices.map(({ days, price, subline }) => (
                                <Col key={days}>
                                    <Cell
                                        styles={{
                                            padding,
                                            whiteSpace: 'nowrap',
                                            justifyContent: 'center',
                                        }}
                                        fw={700}
                                        alignItems={'start'}
                                        flexColumn={1}
                                    >
                                        {days}
                                        {subline && <br />}
                                        {subline && (
                                            <p style={{ fontSize: 'smaller', fontWeight: 500, marginTop: '2px' }}>
                                                {subline}
                                            </p>
                                        )}
                                    </Cell>

                                    <Divider size={2} margin={0} />

                                    <Cell styles={{ padding, whiteSpace: 'nowrap' }} key={`price-${days}-${price}`}>
                                        {price}
                                    </Cell>
                                </Col>
                            ))}
                        </Table>
                    </div>
                </section>

                {pricingText?.map((text, idx) => (
                    <PriceTableText priceText={text} key={`pricingText-${idx}`} />
                ))}

                <LegalNotice />
            </>
        );
    }

    return null;
};

export default Prices;
